import { PriceDistributionSteps } from 'ha/pages/Search/constants';

interface PricesFacet {
  [key: number]: number;
}

export interface PriceDistributionArgs {
  pricesFacet: PricesFacet;
  minPrice: number;
  maxPrice: number;
  rate: number;
}

const getPriceDistribution = ({
  pricesFacet,
  minPrice,
  maxPrice,
  rate,
}: PriceDistributionArgs) => {
  const distribution = {};
  const step = Math.ceil((maxPrice - minPrice) / PriceDistributionSteps);

  const prices = Object.keys(pricesFacet)
    .map(Number)
    .filter(price => price * rate >= minPrice && price * rate <= maxPrice)
    .sort((a, b) => a - b);

  let j = 0;

  for (let i = 0; i < PriceDistributionSteps; i += 1) {
    const bar = minPrice + i * step;
    const nextBar = minPrice + (i + 1) * step;

    distribution[bar] = 0;
    while (prices[j] * rate < nextBar && prices[j] * rate >= bar) {
      distribution[bar] += pricesFacet[prices[j]];
      j += 1;
    }
  }

  return distribution;
};
export { getPriceDistribution };
